import { accountRoutes } from './routes'
export default accountRoutes
